<template>

    <div class="border-dashed border-2 relative rounded cursor-pointer" droppable="droppable"
         @dragenter.prevent="dragenter" @dragleave.prevent="dragleave" @dragover.prevent="dragover($event)"
         @drop.prevent="drop" :class="{'highlight': highlight}" @click="selectFile">
        <input class="hidden" type="file" @change="inputChanged($event)" ref="input"/>
        <slot>
            <div class="text-center">
                <div class="line p-3">Drop or select file here...</div>
                <div class="btn btn-primary">Browse</div>
            </div>
        </slot>
    </div>
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            default: "base64"
        }
    },
    data() {
        return {
            highlight: false
        }
    },
    methods: {
        dragenter() {
            this.highlight = true;
        },
        dragleave() {
            this.highlight = false;
        },
        dragover(evt) {
            // Explicitly show this is a copy
            evt.dataTransfer.dropEffect = 'copy';
            this.highlight = true;
        },
        drop(e) {
            this.highlight = false;
            let dt = e.dataTransfer;
            let files = dt.files;
            this.handleFiles(files);
        },
        inputChanged(evt) {
            this.handleFiles(evt.target.files)
        },
        handleFiles(files) {
            if (!files || !files.length) {
                return
            }
            var f = files[0]
            var reader = new FileReader()
            reader.onload = e => {
                this.$emit('load', {
                    result: e.target.result,
                    name: f.name,
                    size: f.size,
                    type: f.type
                })
            }

            if (this.type == 'text') {
                reader.readAsText(f)
            } else {
                reader.readAsDataURL(f);
            }
        },
        selectFile() {
            this.$refs.input.click()
        },
        change() {
            this.handleFiles(this.$refs.file.files)
        },
    }
};
</script>
<style lang="scss" scoped>
.highlight {
    @apply border-red-600;
}
</style>


